export const OFFER_KIND = Object.freeze({
  PERCENTAGE_OFF_BY_PRODUCTS: 'percentage_off_by_products',
  PERCENTAGE_OFF_BY_MIN_SPEND_VALUE: 'percentage_off_by_min_spend_value',

  AMOUNT_OFF_BY_PRODUCTS: 'amount_off_by_products',
  AMOUNT_OFF_BY_MIN_SPEND_VALUE: 'amount_off_by_min_spend_value',

  FREE_ITEM_BY_PRODUCTS: 'free_item_by_products',
  FREE_ITEM_BY_MIN_SPEND_VALUE: 'free_item_by_min_spend_value',

  BOGO: 'bogo',
  BOGO_HALF_PRICE: 'bogo_half_price',
});

export const OFFER_TYPE = Object.freeze({
  PERCENTAGE_OFF: 'percentage_off',
  AMOUNT_OFF: 'amount_off',
  FREE_ITEM: 'free_item',
  BOGO: 'bogo',
});

export const OFFERS_PRODUCTS_KEYS_BY_KIND = Object.freeze({
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: ['products'],
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: ['products'],
  [OFFER_KIND.BOGO]: ['products'],
  [OFFER_KIND.BOGO_HALF_PRICE]: ['products'],
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: ['products', 'free_products'],
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: ['free_products'],
});
